import { makeStyles } from '@mui/styles';

export  const useStyles = makeStyles(theme => ({
    formControl:{
		minWidth: prop => prop?.width ? prop.width : '25%',
		marginTop: prop => prop?.marginTop ? prop.marginTop : '2%',
		paddingRight: theme.spacing(2),
		'@media (max-width:1200px)':{
			width: '33%'
		},
		'@media (max-width:992px)':{
			width: '50%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '2.5%',
		},
		'@media (max-width:768px)':{
			width: '100%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '3.5%',
		},
    },
}));
